import React from 'react'
import { Box, Typography } from '@mui/material'
const Certificate = () => {
  return (
    <Box display="flex" justifyContent="center"><Typography variant='h4' mt={20}> This page is under developement.</Typography></Box>
  )
}

export default Certificate